
// 陕西鲁泰
const sxlt_banner1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner1.jpg";
const sxlt_banner2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner2.jpg";
const sxlt_banner3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner3.jpg";
const sxlt_banner4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner4.jpg";
const sxlt_banner5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner5.jpg";
const sxlt_banner6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner6.jpg";

const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
    homeData: {
		herderBanner: [sxlt_banner1, sxlt_banner2, sxlt_banner3, sxlt_banner4, sxlt_banner5, sxlt_banner6],
		//企业logo
		logo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/logo.png",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/banner1.jpg",
		isShowVrModal: false,
		isShowVr: false,
		vRurl: "https://fs.m2.com.cn/home/20240171",
		isVideo: false,
		videoLogo: "",
		videoUrl: "",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `鲁泰防水是一家集防水材料研发、生产、销售、施工于一体的科技型企业。旗下有陕西鲁泰防水保温工程有限公司、甘肃金雨洁防水科技有限公司、山东鲁泰防水科技有限公司、陕西鲁泰防水科技有限公司。集团总部位于陕西省咸阳市永寿工业园区，目前在职员工 500余人。专业技术人员40余人。公司主要生产“雨泰”牌、“金雨 洁”牌系列防水卷材及防水涂料。年产各类防水卷材6000万平方米，各类防水涂料5000吨。主要产品有弹性体（SBS）改性沥青防 水卷材、塑性体（APP）改性沥青防水卷材、胶粉改性沥青聚酯毡与玻纤网格布增强防水卷材、高聚物改性沥青防水卷材、种植屋面用耐 根穿刺防水卷材、带自粘层聚合物改性沥青耐根穿刺防水卷材、湿铺 防水卷材、预铺防水卷材、自粘聚合物改性沥青防水卷材；环保水性 单组份聚氨酯防水涂料、聚氨酯高分子防水涂料（单组份/双组 份）、聚合物水泥（JS）复合防水涂料、水泥基渗透结晶防水材料、 非固化橡胶沥青防水涂料、喷涂速凝橡胶沥青防水涂料等，13个系 列、90余种产品。 
		本公司的经营理念是“专业、规范、求实、创新”，引领规范防 水行业健康有序发展，积极致力于防水材料事业的大力发展。
		 目前，公司设立了60余家营销中心或办事机构，营销网络已覆 盖陕西、甘肃、宁夏、青海、新疆、西藏、河南、山东、山西、湖 北、安徽、河北等十二省市和地区。公司通过与国内知名房企、建筑 企业的合作，产品已广泛应用于大型房地产、高铁、地铁、城市地下 综合管廊、工矿厂房等领域。受到客户的高度信任和好评。同时，公司重视客户价值的实现，从工程初期介入，为客户实行全方位、全过 程系统性防水技术服务。
		 公司率先通过ISO9001：2015质量管理体系认证，建立规范的 产品质量体系及优良的服务体系。产品在国家、省区、市级抽检中均呈现优良品质。公司先后荣获“陕西省AAA级信誉企业”、“质量 诚信行业十强”、“陕西省行业名牌企业”、“雨泰”商标被认定为 “陕西省著名商标”，企业应邀成为中国建筑防水材料协会会员单位。  
		忆往昔，峥嵘岁月，感恩邂逅过的每位伙伴，感恩美好时代。 
		展未来，信心百倍，我们一起追梦，一起拼搏，共创美好生活。`,
		//公司官网
		website: "http://www.jinyutai.com.cn/",
		operatingStatus: "正常在业",
		//经营品类
		categories: "防水卷材系列产品、防水涂料系列产品",
		//公司地址
		companyAddress: "陕西省咸阳市永寿县能化建材园区",
		site: "陕西省咸阳市",
		//经营模式
		mode: "1、生产型企业；2、专业承包型企业",
		//注册资金
		capital: "9800万元人民币",
		//成立日期
		establishment: "2013-04-15",
		//经营品牌
		brand: "雨泰",
		//主营产品
		mainProducts: "防水卷材,防水涂料",
		//企业名称
		headerTitle: "陕西鲁泰防水保温工程有限公司",
		moreInfoName: "陕西鲁泰防水保温工程有限公司",
		//供货区域
		supplyArea: "陕西、甘肃、宁夏、青海、新疆、西藏、河南、山东、山西、湖 北、安徽、河北等十二省市和地区",
		//付款条件
		paymentTerms: `1.现款现结
		2.预付款（可与其他项组合）
		3.货到付款
		4.按工程进度付款`,
		//工厂地址
		factoryAddress: "陕西省咸阳市永寿县能化建材园区",
		//工厂人数
		factoryHeadcount: "80",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "区域3-5个",
		factoryHeadcount: "",
		capacity: "4125万平方米",
		annualOutputValue: "4.5万平",

		//联系负责人
		person: "候善锋 ",
		//联系电话
		contactNumber: "13892840911",
		//资质证书
		qualificationList: [
			{
				name: "高新技术企业证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs1.jpg",
			},
			{
				name: "建筑资质证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs2.jpg",
			},
			{
				name: "科小证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs3.jpg",
			},
			{
				name: "职业健康证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs4.jpg",
			},
			{
				name: "环境管理证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs5.jpg",
			},
			{
				name: "质量管理证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs6.jpg",
			},
			{
				name: "生产许可证",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs7.jpg",
			},
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/zzzs8.jpg",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "《绿色建筑选用产品导向目录》入选证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs1.jpg",
			},
			{
				name: "科技型中小企业证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs2.jpg",
			},
			{
				name: "2020中国建材企业500强",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs3.png",
			},
			{
				name: "2020中国建筑防水企业20强",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs4.png",
			},
			{
				name: "2022建材企业500强证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs5.png",
			},
			{
				name: "绿色建筑选用产品(1)",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs6.jpg",
			},
			{
				name: "绿色建筑选用产品(2)",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs7.jpg",
			},
			{
				name: "绿色建筑选用产品(3)",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs8.jpg",
			},
			{
				name: "绿色建筑选用产品(4)",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs9.jpg",
			},
			{
				name: "中国建筑防水协会会员",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/ryzs10.jpg",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "中天西北建设",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhb1.png",
				desc: "",
			},
			{
				name: "陕西建工第二建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhb2.png",
				desc: "",
			},
			{
				name: "陕西建工第六建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhb2.png",
				desc: "",
			},
			{
				name: "陕西建工第七建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhb2.png",

				desc: "",
			},
			{
				name: "中铁二十一局第四工程有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhb3.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 27,
				num: 46,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 1127,
				num: 11,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "36亿+",
				num: 24,
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
    listData: {
		productList: [
			{ name: "弹性体改性沥青防水卷", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt1.png" },
			{
				name: "塑性体APP改性沥青防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt2.png",
			},
			{
				name: "改性沥青聚乙烯胎防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt3.png",
			},
			{
				name: "种植屋面用耐根穿刺防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt4.png",
			},
			{
				name: "高聚物改性沥青防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt5.png",
			},
			{
				name: "胶粉改性沥青聚酯毡与玻纤网格布增强防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt6.png",
			},
			{
				name: "带自粘层聚合物改性沥青耐根穿刺防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt7.png",
			},
			{
				name: "带自粘层的弹性体改性沥青防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt8.png",
			},
			{
				name: "无胎自粘聚合物改性沥青防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt9.png",
			},
			{
				name: "聚酯胎自粘聚合物改性沥青防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt10.png",
			},
			{
				name: "高强度高分子反应粘结型防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt11.png",
			},
			{
				name: "高延伸高分子反应粘结型防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt12.png",
			},
			{
				name: "高分子自粘胶膜预铺防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt13.png",
			},
			{
				name: "聚氯乙烯 (PVC)防水卷材",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt14.png",
			},
			{ name: "聚合物水泥防水涂料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt15.png" },
			{
				name: "水泥基渗透结晶型防水涂料",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png",
			},
			{ name: "液体卷材防水涂料", img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt17.png" },
			{
				name: "金属屋面丙烯酸高弹防水涂料",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt18.png",
			},
			{
				name: "高弹丙烯酸酯防水涂料",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt19.png",
			},
			{
				name: "非固化橡胶沥青防水涂料",
				img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt20.png",
			},
		],
		navList: [
			{
				name: "防水卷材",
				isShow: false,
				id: 1,
				children: [
					"橡塑保温材料-弹性体改性沥青防水卷",
					"塑性体APP改性沥青防水卷材",
					"改性沥青聚乙烯胎防水卷材",
					"种植屋面用耐根穿刺防水卷材",
					"高聚物改性沥青防水卷材",
					"胶粉改性沥青聚酯毡与玻纤网格布增强防水卷材",
					"带自粘层聚合物改性沥青耐根穿刺防水卷材",
					"无胎自粘聚合物改性沥青防水卷材",
				],
			},
			{
				name: "防水涂料",
				isShow: false,
				id: 2,
				children: [
					"聚合物水泥防水涂料",
					"水泥基渗透结晶型防水涂料",
					"液体卷材防水涂料",
					"金属屋面丙烯酸高弹防水涂料",
					"高弹丙烯酸酯防水涂料",
					"非固化橡胶沥青防水涂料",
				],
			},
		],
	},
    productDetailsData:	{
		弹性体改性沥青防水卷: {
			name: "弹性体改性沥青防水卷",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt1.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt1.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt1.png"],
			modelNumberText: "TR-200",
			brand: "雨泰",
			describe:
				"塑性体APP 改性沥青防水卷材是以无规聚丙烯 (APP) 或聚烯烃类聚合物(APAO、APO  等)作石油沥青改性剂，以优质聚酯毡、玻纤毡、玻纤增强聚酯毡为胎基，两面覆以隔离材料所制成的防水卷材",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht1.png"],
		},
		塑性体APP改性沥青防水卷材: {
			name: "塑性体APP改性沥青防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt2.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt2.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt2.png"],
			modelNumberText: "YTR-300",
			brand: "雨泰",
			describe:
				"改性沥青聚乙烯胎防水卷材是以高密度聚乙烯膜为胎基，上下两面覆以高聚物改性沥青或自粘聚合物改性沥青，表面覆盖隔离材料制成的防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		改性沥青聚乙烯胎防水卷材: {
			name: "塑性体APP改性沥青防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt3.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt3.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt3.png"],
			modelNumberText: "YTR-4000",
			brand: "雨泰",
			describe:
				"改性沥青聚乙烯胎防水卷材是以高密度聚乙烯膜为胎基，上下两面覆以高聚物改性沥青或自粘聚合物改性沥青，表面覆盖隔离材料制成的防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		种植屋面用耐根穿刺防水卷材: {
			name: "种植屋面用耐根穿刺防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt4.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt4.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt4.png"],
			modelNumberText: "YTR-5000",
			brand: "雨泰",
			describe:
				"改性沥青聚乙烯胎防水卷材是以高密度聚乙烯膜为胎基，上下两面覆以高聚物改性沥青或自粘聚合物改性沥青，表面覆盖隔离材料制成的防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		高聚物改性沥青防水卷材: {
			name: "高聚物改性沥青防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt5.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt5.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt5.png"],
			modelNumberText: "YTR-6000",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		胶粉改性沥青聚酯毡与玻纤网格布增强防水卷材: {
			name: "胶粉改性沥青聚酯毡与玻纤网格布增强防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt6.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt6.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt6.png"],
			modelNumberText: "YTR-100",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		带自粘层聚合物改性沥青耐根穿刺防水卷材: {
			name: "带自粘层聚合物改性沥青耐根穿刺防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt7.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt7.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt7.png"],
			modelNumberText: "YTZ-5000",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		带自粘层的弹性体改性沥青防水卷材: {
			name: "带自粘层的弹性体改性沥青防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt8.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt8.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt8.png"],
			modelNumberText: "YTZ-6000",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		无胎自粘聚合物改性沥青防水卷材: {
			name: "无胎自粘聚合物改性沥青防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt9.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt9.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt9.png"],
			modelNumberText: "YTZ-6000",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		聚酯胎自粘聚合物改性沥青防水卷材: {
			name: "聚酯胎自粘聚合物改性沥青防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt10.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt10.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt10.png"],
			modelNumberText: "YTT-",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		高强度高分子反应粘结型防水卷材: {
			name: "高强度高分子反应粘结型防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt11.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt11.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt11.png"],
			modelNumberText: "YTT-",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		高延伸高分子反应粘结型防水卷材: {
			name: "高延伸高分子反应粘结型防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt12.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt12.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt12.png"],
			modelNumberText: "YTT-",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		高分子自粘胶膜预铺防水卷材: {
			name: "高分子自粘胶膜预铺防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt13.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt13.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt13.png"],
			modelNumberText: "YTZ-200",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		"聚氯乙烯 (PVC)防水卷材": {
			name: "聚氯乙烯 (PVC)防水卷材",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt14.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt14.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt14.png"],
			modelNumberText: "YTZ-200",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		聚合物水泥防水涂料: {
			name: "聚合物水泥防水涂料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt15.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt15.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt15.png"],
			modelNumberText: "YTZ-200",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		水泥基渗透结晶型防水涂料: {
			name: "水泥基渗透结晶型防水涂料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png"],
			modelNumberText: "YTZ-200",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		液体卷材防水涂料: {
			name: "液体卷材防水涂料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt16.png"],
			modelNumberText: "YTZ-200",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		金属屋面丙烯酸高弹防水涂料: {
			name: "金属屋面丙烯酸高弹防水涂料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt17.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt17.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt17.png"],
			modelNumberText: "YTT-",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		高弹丙烯酸酯防水涂料: {
			name: "高弹丙烯酸酯防水涂料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt18.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt18.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt18.png"],
			modelNumberText: "YTT-",
			brand: "雨泰",
			describe:
				"高聚物改性沥青防水卷材是专用于铁路桥梁和涵洞防水，它是以特殊加工的长纤聚酯无纺布为胎基，特殊配方制成的高聚物改性沥青做浸渍和涂盖材料，两面覆以细砂隔离材料所制成的一种超高性能改性沥青防水卷材。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
		非固化橡胶沥青防水涂料: {
			name: "非固化橡胶沥青防水涂料",
			img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt19.png",
			modelNumber: [
				{
					title: "暂无",
					img: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt19.png",
				},
			],
			price: "暂无",
			detailImgs: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/sxlt19.png"],
			modelNumberText: "YTT-",
			brand: "雨泰",
			describe:
				"非固化橡胶沥青防水涂料是一种新型环保、高固含量的热熔型沥青防水涂料，以橡胶、沥青为主要组分，加入助剂混合制成的在使用年限内保持粘性膏状体的防水涂料。具有与空气长期接触后不固化，能保持粘稠胶质的特性，自愈能力强，碰触即粘，难以剥离；能解决因基层开裂应力传递给防水层而造成的防水层开裂、疲劳破坏或处理高应力状态下提前老化的问题；同时，材料的粘滞性能够很好的封闭基层的毛细孔和裂缝，解决防水层的窜水难题；还能解决现有防水卷材和防水涂料复合使用时相容性差的问题。",
			report: ["https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png"],
		},
	},
    contactListData: {
		list: [
			{
				name: "候善锋",
				position: "销售总监(陕西)",
				id: "3",
				phoneNum: "--",
				telephone: "13892840911",
				color: "#219b94",
				email: "--",
			},
			{
				name: "刘丽",
				position: "区域经理(西安、咸阳)",
				id: "2",
				phoneNum: "15934836563",
				telephone: "--",
				color: "#007DFF ",
				email: "441337415@qq.com",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "观湖悦府",
				id: 1,
				price: "560万",
				time: "2019年",
				site: "河南许昌",
				type: "地产",
				unit: "中建七局第四建筑有限公司",
				desc: "以鹿为主题的八大园区是整个春天的活力所在，奇花异草名贵林木丛生，造就一方都市中的秘密花园。在这里，楼栋布局错落有致，景观资源的优势被充分放大，最大超200米宽阔楼间距规划，每一户都能享受到绝佳的观景视野。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl1.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht1.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht2.png" },
				],
				product: "SBS改性沥青防水卷材、种植屋面用耐根穿刺防水卷材、非固化改性沥青防水涂料",
			},

			{
				name: "西安地铁八号线",
				id: 2,
				price: "90万",
				time: "2019年",
				site: "陕西西安",
				type: "基础建设",
				unit: "西安市轨道交通集团有限公司",
				desc: "国家会展中心(天津)该项目总长50KM，为西安地铁重要线路，铁路局及中铁公司对该项目极其重视，地下环境复杂，施工难度大，对材料品质要求极高。我公司完美完成本次供货，获得业主方、施工方、监理方三方高度认可。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl2.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht3.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht4.png" },
				],
				product: "聚氨酯防水涂料、水泥基渗透结晶防水涂料",
			},

			{
				name: "菏泽高铁站",
				id: 3,
				price: "600万",
				time: "2020年",
				site: "山东菏泽",
				type: "基础建设",
				unit: "中国一冶集团有限公司",
				desc: "菏泽高铁站一般指菏泽东站。菏泽东站(Hezedong Railway Station)位于中国山东省菏泽市定陶区桶子河村，由中国铁路济南局集团有限公司管辖，距菏泽市区7.6km，距定陶区12.7km，距菏泽站约10km，距菏泽机场约20km。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl3.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht5.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht6.png" },
				],
			},

			{
				name: "西安铁路局火车站站改项目",
				id: 4,
				price: "120万",
				time: "2019年",
				site: "陕西西安",
				type: "基础建设",
				unit: "中国铁路西安局集团有限公司",
				desc: "西安火车站目前为6台9线，日均办理各类旅客列车月250列，日均发送旅客月7.7万人次，有效候车面积为7000多平方米。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl4.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht7.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht8.png" },
				],
				product: "SBS改性沥青防水卷材、种植屋面用耐根穿刺防水卷材",
			},
			{
				name: "商丘宁陵内湖湿地棚户区改造",
				id: 5,
				price: "500万",
				time: "2019年",
				site: "江西省赣州市",
				type: "地产",
				unit: "宁陵县内湖湿地棚改建设有限公司",
				desc: "主要建设内容:河南商丘市宁陵县老城区内湖湿地棚户区改造项目宁安新城5#地块 建筑面积约185000平方米",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl5.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht9.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht10.png" },
				],
				product: "SBS改性沥青防水卷材、种植屋面用耐根穿刺防水卷材、非固化改性沥青防水涂料",
			},
			{
				name: "融创御河宸院",
				id: 6,
				price: "1700万",
				time: "2023年",
				site: "陕西省咸阳市",
				type: "住宅",
				unit: "地产融创",
				desc: "该项目总建筑面积为新建多栋11至34层小高、高层住宅楼(精 装修)，项目占地面积大，为融创地产项目。甲方对防水品牌、质量均要求严格，我公司在供货过程中，无任何质量问题。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl6.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht9.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht10.png" },
				],
				product: "防水卷材、涂料",
			},
			{
				name: "乾陵游客中心建设项目",
				id: 7,
				price: "140万",
				time: "2022年",
				site: "陕西省咸阳市",
				type: "公共建筑",
				unit: "陕建华山建设",
				desc: "该项目为一栋单层高精装修的游客中心，总建筑面积约为11,585平方米，项目设计材料为SBS改性沥青防水卷材及TPO预铺防水卷材，项目要求严格。我公司独立分包该项目，标准化施工、获得项目部高度认可",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sxlt/hzhl7.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht9.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht10.png" },
				],
				product: "防水卷材、涂料",
			},
			{
				name: "红星安置小区",
				id: 8,
				price: "200万",
				time: "2019年",
				site: "陕西省渭南市",
				type: "房建",
				unit: "陕西恒昌房地产开发公司",
				desc: "该项目为总建筑面积142,505平方米，新建包含7幢数层高简单装修的安置楼，其中包拮住宅楼、商业、地下车库、及公共配套设施等。项目位于渭南市核心区域，甲方直接采购防水，对我公司产品质量给与高度评价，项目二期也直接选定我们产品。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/imag/sxlt/hzhl8.png" }],
				// 合作证明图
				contractList: [
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht9.png" },
					{ title: "", path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/szjn/szht10.png" },
				],
				product: "防水卷材、涂料",
			},
		],
	},
    evaluationData:{
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge2.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg2.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 1,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		], //实力徽章

		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/waterproof.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/waterproof.png`,
				subtitle: "防水协会会员",
				isShow: true,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge2.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg2.png`,
				subtitle: "绿建认证",
				isShow: true,
			},
		],
	},
    successfulBidderData: {
		info: [
			{
				name1: "陕建一建集团-市政路桥公司-洋县孵化园-园区管理服务中心防水材料采购计划采购任务",
				name2: "陕建一建集团-市政路桥公司-洋县孵化园-园区管理服务中心防水材料采购计划采购任务",
				name3: "物资采购",
				date: "2021/12/1",
			},
			{
				name1: "西北大学现代学院周至建设项目防水卷材（补）采购计划采购任务",
				name2: "西北大学现代学院周至建设项目防水卷材（补）采购计划采购任务",
				name3: "物资采购",
				date: "2021/9/23",
			},
			{
				name1: "陕建一建-三公司-南泥湾大生产情景风貌街区项目-防水材料采购计划采购任务",
				name2: "陕建一建-三公司-南泥湾大生产情景风貌街区项目-防水材料采购计划采购任务",
				name3: "物资采购",
				date: "2021/9/22",
			},
			{
				name1: "陕建一建集团-市政路桥公司-洋县孵化园-园区管理服务中心防水材料采购计划采购任务",
				name2: "陕建一建集团-市政路桥公司-洋县孵化园-园区管理服务中心项目",
				name3: "物资采购",
				date: "2021/8/21",
			},
			{
				name1: "菏泽东站广场综合体及配套项目防水三标段",
				name2: "菏泽东站广场综合体及配套项目",
				name3: "物资采购",
				date: "2020/12/11",
			},
			{
				name1: "蟠龙新区小韩村道路项目防水工程专业分包询价采购",
				name2: "蟠龙新区小韩村道路项目防水工程专业分包询价采购",
				name3: "物资采购",
				date: "2019/3/1",
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "第二工程公司+西安新竹防务应急科技产业园+防水工程专业分包合同",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "西安新竹防务应急科技产业园",
				"name3": "专业分包",
				"date": "2023年5月26日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团2023年度防水材料大单采购计划（一）任务",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "采购管理部",
				"name3": "物资框架采购",
				"date": "2023年4月10日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "西安北至机场城际轨道项目买卖合同",
				"name4": "陕西建工第十建设集团有限公司",
				"name2": "西安北至机场城际轨道项目生产指挥中心大楼工程施工",
				"name3": "物资采购",
				"date": "2022年10月26日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-第六公司-西安市长安一中新建综合教学楼项目-防水材料采购",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "西安市长安一中新建综合教学楼项目",
				"name3": "物资采购",
				"date": "2022年10月17日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-三公司-未来产业设计研发中心项目-防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "未来产业设计研发中心项目",
				"name3": "物资采购",
				"date": "2022年10月19日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-一公司-空港真爱健康中心项目-防水材料采购",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "空港真爱健康中心",
				"name3": "物资采购",
				"date": "2022年10月10日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "第一工程公司-乾陵游客中心建设工程（项目） 建设工程防水工程专业分包合同",
				"name4": "陕西华山建设集团有限公司",
				"name2": "乾陵游客中心建设项目",
				"name3": "专业分包",
				"date": "2022年9月1日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团2022年度防水材料大单采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "采购管理部",
				"name3": "物资框架采购",
				"date": "2022年5月29日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-市政路桥公司-洋县孵化园-园区管理服务中心防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "洋县移民（脱贫）搬迁产业孵化基地项目（苏陕）",
				"name3": "物资采购",
				"date": "2021年12月8日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-三公司-南泥湾大生产情景风貌街区项目-防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "南泥湾大生产情景风貌街区",
				"name3": "物资采购",
				"date": "2021年10月12日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-市政路桥公司-洋县孵化园-园区管理服务中心防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "洋县移民（脱贫）搬迁产业孵化基地项目（苏陕）",
				"name3": "物资采购",
				"date": "2021年8月27日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-市政路桥公司-雁塔区2020年老旧小区改造项目（太白小区）-防水材料采购计划采购协议",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "雁塔区2020年老旧小区改造项目（太白小区）",
				"name3": "物资采购",
				"date": "2021年5月17日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "2021年度防水材料大单战略合作协议（鲁泰）",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "采购管理部",
				"name3": "物资框架采购",
				"date": "2021年4月15日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-第六公司-中航富士达产业基地项目（二期）-防水材料",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "中航富士达产业基地项目",
				"name3": "物资采购",
				"date": "2020年12月31日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-三公司-西安恒大文化旅游城D-01地块四标段项目防水材料采购协议",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "西安恒大童世界项目D-01地块（四标段）主体及配套建设工程",
				"name3": "物资采购",
				"date": "2019年10月28日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "汉阴县中医医院综合住院楼建设项目-防水材料",
				"name4": "陕西建工第二建设集团有限公司",
				"name2": "汉阴县中医医院综合住院楼建设项目",
				"name3": "物资采购",
				"date": "2020年9月4日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "福门耀里中心项目防水专业分包合同",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "福门耀里中心",
				"name3": "专业分包",
				"date": "2020年9月17日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-市政路桥公司-咸阳市渭河河堤路（渭河南岸）加固改造工程A标段-防水卷材材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "咸阳市渭河河堤路（渭河南岸）加固改造工程A标段",
				"name3": "物资采购",
				"date": "2020年8月10日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-陕北公司-蒙泰集团新材料、新能源和高技术产业研发中心项目-防水劳务分包合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "蒙泰集团新材料、新能源和高新技术产业研发中心工程",
				"name3": "劳务分包",
				"date": "2020年7月5日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-市政路桥公司-大西安（咸阳）文化体育功能区广场路工程-防水材料合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "大西安（咸阳）文化体育功能区广场路工程",
				"name3": "物资采购",
				"date": "2020年7月28日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-陕北公司-蒙泰集团新材料、新能源和高技术产业研发中心项目-防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "蒙泰集团新材料、新能源和高新技术产业研发中心工程",
				"name3": "物资采购",
				"date": "2020年7月5日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "建设工程买卖合同",
				"name4": "陕西建工第二建设集团有限公司",
				"name2": "沣西新城天福和园二期（D3#、D4#楼及地下车库）",
				"name3": "物资采购",
				"date": "2018年9月25日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-市政路桥公司-洋县孵化园苏陕、电子产业园防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "洋县移民（脱贫）搬迁产业孵化基地项目",
				"name3": "物资采购",
				"date": "2020年6月22日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-陕北公司-神木职业技术学院实训大楼-防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "神木职业技术学院实训大楼",
				"name3": "物资采购",
				"date": "2020年5月20日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-陕北公司-神木职业技术学院实训大楼-防水劳务合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "神木职业技术学院实训大楼",
				"name3": "劳务分包",
				"date": "2020年5月20日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团六公司-四季荟综合体-防水劳务合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "四季荟综合体项目",
				"name3": "劳务分包",
				"date": "2020年4月20日"
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "莲湖区2019年北宁坊等老旧小区改造EPC项目总承包招标防水材料采购合同",
				"name4": "陕西建工第八建设集团有限公司",
				"name2": "莲湖区2019年北宁坊等老旧小区改造EPC项目总承包招标",
				"name3": "物资采购",
				"date": "2020年4月16日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团2020年度（鲁泰）防水材料大单采购",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "采购管理部",
				"name3": "物资框架采购",
				"date": "2020年3月26日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建六公司-渭南润泽臻品二期项目-防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "渭南润泽臻品项目",
				"name3": "物资采购",
				"out": true,
				"date": "2020年3月18日"
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "渭南市老城区毕家村等3个棚户区改造项目二标段B5#楼防水工程",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "渭南市老城区毕家村等3个棚户区改造项目二标段B5#楼",
				"name3": "专业分包",
				"date": "2019年11月8日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-陕北公司-蒙泰集团新材料、新能源和高技术产业研发中心项目-防水劳务分包合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "蒙泰集团公司新建科研楼、综合楼",
				"name3": "劳务分包",
				"date": "2019年8月10日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建集团-陕北公司-蒙泰集团新材料、新能源和高技术产业研发中心项目-防水材料采购合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "蒙泰集团公司新建科研楼、综合楼",
				"name3": "物资采购",
				"date": "2019年8月15日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "安康高新区飞地新经济产业园项目防水专业分包合同",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "安康高新区飞地新经济产业园项目",
				"name3": "专业分包",
				"date": "2019年6月1日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "2019.4.13西咸新区秦汉中心医院EPC项目防水专业分包",
				"name4": "陕西建工第六建设集团有限公司",
				"name2": "西咸新区秦汉中心医院",
				"name3": "专业分包",
				"date": "2019年5月7日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建-2019年度-防水材料大单采购协议（鲁泰）",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "采购管理部",
				"name3": "物资框架采购",
				"date": "2019年3月15日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕建一建第六公司-西北工业大学友谊校区七号学生公寓-防水劳务分包",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "西北工业大学友谊校区七号学生公寓建设项目",
				"name3": "劳务分包",
				"date": "2019年3月15日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "陕西一建集团第一工程部汉中天汉文化公园A3#楼及地下室工程车库塔基防水专业承包合同",
				"name4": "陕西建工第一建设集团有限公司",
				"name2": "汉中市滨江新区天汉文化公园A区A3#楼及地下室工程",
				"name3": "专业分包",
				"date": "2018年12月20日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "屋面防水和防水地面工程专业分包合同",
				"name4": "陕西建工第九建设集团有限公司",
				"name2": "陕西建工第九建设集团有限公司四分司洛南县污水处理厂扩容提标改造工程",
				"name3": "专业分包",
				"date": "2018年9月18日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "秦汉新城双照社区服务中心防水专业分包",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "秦汉新城双照社区服务中心",
				"name3": "专业分包",
				"date": "2018年8月31日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "综合管廊防水分包合同",
				"name4": "陕西华山路桥集团有限公司",
				"name2": "秦汉新城秦震路工程",
				"name3": "专业分包",
				"date": "2016年9月13日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "秦政大道（天汉大道-汉都一路）市政工程-防水工程专业分包",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "秦政大道（天汉大道-汉都一路）市政工程",
				"name3": "专业分包",
				"date": "2018年7月12日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "国家钛材质监检验中心新材料检测平台项目防水工程",
				"name4": "陕西建工安装集团有限公司",
				"name2": "国家钛材质监检验中心新材料检测平台项目",
				"name3": "专业分包",
				"date": "2018年5月2日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "渭南市临渭区老城区毕家村等3个村棚户区改造项目5#楼防水采购合同采购任务",
				"name4": "陕西建工第四建设集团有限公司",
				"name2": "渭南市临渭区老城区毕家村等3个村棚户区改造项目5#楼",
				"name3": "物资采购",
				"date": "2017年12月12日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "姬家乡防水采购",
				"name4": "陕西建工第十建设集团有限公司",
				"name2": "高陵姬家乡集中安置社区二期",
				"name3": "物资采购",
				"date": "2017年5月15日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "司马追风阁屋面防水施工合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "司马追风阁",
				"name3": "劳务分包",
				"date": "2016年8月11日",
				"out": true
			},
			{
				"企业名称": "陕西鲁泰防水科技有限公司",
				"name1": "司马追风阁防水施工合同",
				"name4": "陕西建工第三建设集团有限公司",
				"name2": "司马追风阁",
				"name3": "专业分包",
				"date": "2016年10月31日",
				"out": true
			}
		],
	},
    lawData: {
		info: [
			{
				caseName: "苗丕民、李传迎等提供劳务者受害责任纠纷民事一审民事裁定书",
				reference: "（2021）苏0312民初10382号",
				cause: "提供劳务者受害责任纠纷",
				identity: "被告",
				caseType: "民事案件",
				date: "2021-11-30",
			},
		],
	},
    tipData:{
		info: [
			{
				title: "陕建云采会员",
			},
		],
	},
}